import { Route } from 'react-router-dom';
import isEmpty from 'ramda/src/isEmpty';
import { SessionRedirect } from '../../../common/sessionRedirect';
import { UserSession } from 'ascendon-web-toolkit/utils';
import { useEffect } from 'react';
import postMessage from '../../../utils/postMessage';

export const PrivateRoute = ({ component: Component, ...rest }) => {
  useEffect(() => {
    postMessage('module.hideBackdrop');
  }, []);

  return (
    <Route
      {...rest}
      render={() =>
        UserSession.sessionData && !isEmpty(UserSession.sessionData) ? (
          <Component {...rest} />
        ) : (
          <SessionRedirect {...rest} />
        )
      }
    />
  );
};
